import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tag } from 'primereact/tag'
import MercosulPlate from 'shared/mercosul-plate/mercosul-license-plate'
import { colorMapping, vehicleTypeMap } from '../../../utils/notification-utils'

interface VehicleInfoCardProps {
  metadata: Record<string, string>
}

const getVehicleType = (vehicleType: string) => {
  const type = vehicleTypeMap[vehicleType as keyof typeof vehicleTypeMap]
  if (!type) return null
  return (
    <Tag
      severity='info'
      value={
        <>
          <FontAwesomeIcon icon={type.icon} size='sm' className='mr-1' />
          {type.label}
        </>
      }
    />
  )
}

const getVehicleColor = (color: string) => {
  const displayColor =
    colorMapping[color.toLowerCase() as keyof typeof colorMapping] || color || 'Não identificado'
  return (
    <span className={`events-color-badge events-color-${color.toLowerCase() || 'unknown'}`}>
      <i className='pi pi-circle-fill' />
      {displayColor}
    </span>
  )
}

const VehicleInfoCard = ({ metadata }: VehicleInfoCardProps) => (
  <div className='detail-card'>
    <h4>
      <i className='pi pi-car mr-2' />
      Informações do Veículo
    </h4>
    <div className='detail-grid'>
      {metadata.LicensePlate && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-id-card mr-1' />Placa:</span>
          <span className='detail-value'>
            <MercosulPlate licensePlate={metadata.LicensePlate} size='S' />
          </span>
        </div>
      )}

      {metadata.VehicleType && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-cog mr-1' />Tipo:</span>
          <span className='detail-value'>{getVehicleType(metadata.VehicleType)}</span>
        </div>
      )}

      {metadata.VehicleColor && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-palette mr-1' />Cor:</span>
          <span className='detail-value'>{getVehicleColor(metadata.VehicleColor)}</span>
        </div>
      )}

      {metadata.Brand && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-building mr-1' />Marca:</span>
          <span className='detail-value'>{metadata.Brand}</span>
        </div>
      )}

      {metadata.Model && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-objects-column mr-1' />Modelo:</span>
          <span className='detail-value'>{metadata.Model}</span>
        </div>
      )}

      {metadata.Year && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-calendar mr-1' />Ano:</span>
          <span className='detail-value'>{metadata.Year}</span>
        </div>
      )}
    </div>
  </div>
)

export default VehicleInfoCard
